
import { Model, attr, Session, fk, many } from 'redux-orm'
import { IORMModels, ISession } from 'src/Config/ConfigureOrm';
import { AppAction } from 'src';
import Activity, { IActivityModel } from '../Activity/Activity';
import { IActivityThemeModel } from '../ActivityTheme/ActivityTheme';

export interface IActivityCategoryModel{
    categoryId: number;
    themeId: number;
    name: string;
    
    activities: Activity[];
    
}


export default class ActivityCategory extends Model<IActivityCategoryModel> implements IActivityCategoryModel{
    public static modelName = 'ActivityCategory';
    public static fields  = {
        categoryId: attr({}),
        name: attr({}),
        activities: many('Activity', 'category'),
        themeId: attr({})
    }
    public static reducer(action: AppAction<any>, activity: typeof Model, session: ISession<IORMModels>){
        switch(action.type){

        }

    }
    public categoryId : number;
    public themeId: number;
    public name :string;
    public activities :Activity[];
    
}



// WEBPACK FOOTER //
// ./src/Entities/ActivityCategory/ActivityCategory.ts